module.exports = __webpack_public_path__ + "static/media/push-inapp.1c711dde.svg";